import React from 'react';
import { useLocales } from '@/locales';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const NewFaq2 = () => {
  const { translate } = useLocales();

  const faqItems = [
    {
      id: 'panel1',
      number: '01',
      question: 'How_to_pay',
      answer: 'How_to_pay_answer',
    },
    {
      id: 'panel2',
      number: '02',
      question: 'How_to_create_answer_one',
      answerContent: (
        <>
          {translate('How_to_create_answer_two')}
          <br /> 1. {translate('How_to_create_answer_three')}
          <br /> 2. {translate('How_to_create_answer_four')}
          <br /> 3. {translate('How_to_create_answer_five')}
          <br /> 4. {translate('How_to_create_answer_six')}
        </>
      ),
    },
    {
      id: 'panel3',
      number: '03',
      question: 'Check_TNVED_answer_one',
      answerContent: (
        <>
          {translate('Check_TNVED_answer_two')}
          <br />
          <a
            rel="noreferrer"
            href="http://tarif.customs.uz/spravochnik/viewDatatable.jsp?lang=ru_Ru"
            target="_blank"
            className="text-blue"
          >
            http://tarif.customs.uz/spravochnik/viewDatatable.jsp?lang=ru_Ru
          </a>
        </>
      ),
    },
    {
      id: 'panel4',
      number: '04',
      question:
        'To_check_the_certificate_of_origin_of_goods_you_can_use_the_following_sites',
      answerContent: (
        <>
          1. {translate('Check_CPT_Chambers_of_Industry')} -{' '}
          <a
            target="_blank"
            href="https://certificates.iccwbo.org/"
            rel="noreferrer"
          >
            https://certificates.iccwbo.org/
          </a>
          <br /> 2. {translate('Check_SPT_Russia')} -{' '}
          <a
            target="_blank"
            href="https://verification.tpprf.ru/search/st1"
            rel="noreferrer"
          >
            https://verification.tpprf.ru/search/st1
          </a>
          <br /> 3. {translate('Check_SPT_China')} -{' '}
          <a target="_blank" href="http://check.ccpiteco.net/" rel="noreferrer">
            http://check.ccpiteco.net/
          </a>
          <br /> 4. {translate('Check_SPT_Korea')} -{' '}
          <a
            target="_blank"
            href="http://cert.korcham.net/search"
            rel="noreferrer"
          >
            http://cert.korcham.net/search
          </a>
          <br /> 5. {translate('Check_SPT_Germany')} -{' '}
          <a target="_blank" href="https://cert.ihk.de/#/home" rel="noreferrer">
            https://cert.ihk.de/#/home
          </a>
          <br /> 6. {translate('Check_SPT_Argentina')} -{' '}
          <a
            target="_blank"
            href="https://www.certificateoforigin.com/"
            rel="noreferrer"
          >
            https://www.certificateoforigin.com/
          </a>
          <br /> 7. {translate('Check_SPT_Ukrain')} -{' '}
          <a
            target="_blank"
            href="https://verify.ucci.org.ua/ru"
            rel="noreferrer"
          >
            https://verify.ucci.org.ua/ru
          </a>
        </>
      ),
    },
  ];

  return (
    <div className="container mx-auto">
      <div className="newFaq2">
        <h1 className="newFaq2__title">{translate('Question')}</h1>

        <Accordion
          type="single"
          collapsible
          defaultValue="panel1"
          className="w-full"
        >
          {faqItems.map((item, index) => (
            <AccordionItem
              key={item.id}
              value={item.id}
              className={`border-x-0 ${index === faqItems.length - 1 ? 'rounded-b-none' : 'rounded-b-[50px]'}`}
            >
              <AccordionTrigger className="px-4 py-3 bg-[rgba(232,247,255,0.6)] dark:bg-card hover:no-underline">
                <div className="flex items-center gap-4 text-left">
                  <span className="font-montserrat font-bold text-2xl text-gray-800 dark:text-card-foreground">
                    {item.number}
                  </span>
                  <span className="font-montserrat font-bold text-xl text-gray-800 dark:text-card-foreground">
                    {translate(item.question)}
                  </span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="px-4 py-4 bg-[rgba(232,247,255,0.6)] dark:bg-card dark:text-card-foreground">
                <p>{item.answerContent || translate(item.answer)}</p>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default NewFaq2;
